/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1InsidepapersQueryResponse } from '../../types/GetV1Insidepapers.ts'

export const getV1InsidepapersQueryKey = () => [{ url: '/v1/InsidePapers' }] as const

export type GetV1InsidepapersQueryKey = ReturnType<typeof getV1InsidepapersQueryKey>

/**
 * {@link /v1/InsidePapers}
 */
export async function getV1Insidepapers(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<GetV1InsidepapersQueryResponse, ResponseErrorConfig<Error>, unknown>({
        method: 'GET',
        url: `/v1/InsidePapers`,
        ...requestConfig,
    })
    return res
}

export function getV1InsidepapersQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1InsidepapersQueryKey()
    return queryOptions<
        ResponseConfig<GetV1InsidepapersQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1InsidepapersQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Insidepapers(config)
        },
    })
}

/**
 * {@link /v1/InsidePapers}
 */
export function useGetV1Insidepapers<
    TData = ResponseConfig<GetV1InsidepapersQueryResponse>,
    TQueryData = ResponseConfig<GetV1InsidepapersQueryResponse>,
    TQueryKey extends QueryKey = GetV1InsidepapersQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1InsidepapersQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1InsidepapersQueryKey()

    const query = useQuery(
        {
            ...getV1InsidepapersQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
